import { useStickyShadowStyle } from "./useStickyShadowStyle";

import React from "react";
import { Animated } from "react-native";

export type StickyShadowProps = React.PropsWithChildren<{
  enabled?: boolean;
}>;

/**
 * Adds a shadow around the underlying component, i.e. an apply button.
 *
 * Note, that the styling for the sticky is platform dependent.
 */
export const StickyShadow = (props: StickyShadowProps) => {
  const optionalStickyStyle = useStickyShadowStyle();

  if (!props.enabled || !optionalStickyStyle) {
    return props.children;
  }

  return (
    <Animated.View style={optionalStickyStyle} testID="sticky-shadow-test">
      {props.children}
    </Animated.View>
  );
};
